import Api from './api'

export default {

    get: function () {

        return Api.get('/v3/users/referrals')


    },

    getAll: function () {

        return Api.get('/trees/all')
            .catch(() => { redirectMainPage() })

    },

    getByPartner: function (partnerCode) {

        return Api.get(`/trees/${partnerCode}`)
            .catch(() => { redirectMainPage() })

    },

    addCode: function (code) {

        return Api.put(`/v3/users/referrals/code/${ code }`)

    }

}

function redirectMainPage () {

    window.location.href = '/'

}

